type Props = {
  value: number;
  onChange: (v: number) => void;
  max?: number;
  min?: number;
};

export default function QuantityStepper({ value, onChange, max = 99, min = 1 }: Props) {
  const dec = () => onChange(Math.max(min, value - 1));
  const inc = () => onChange(Math.min(max, value + 1));
  return (
    <div className="inline-flex items-center h-12 rounded-full border border-background-300/80 bg-background-50">
      <button
        type="button"
        onClick={dec}
        disabled={value <= min}
        className="w-12 h-12 flex items-center justify-center rounded-full text-foreground-800 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
        aria-label="Decrease quantity"
      >
        <i className="ri-subtract-line"></i>
      </button>
      <span className="w-10 text-center text-sm font-medium text-foreground-950 select-none">
        {value}
      </span>
      <button
        type="button"
        onClick={inc}
        disabled={value >= max}
        className="w-12 h-12 flex items-center justify-center rounded-full text-foreground-800 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
        aria-label="Increase quantity"
      >
        <i className="ri-add-line"></i>
      </button>
    </div>
  );
}